"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.getNewViewCount = getNewViewCount;
var _getLogger = _interopRequireDefault(require("./getLogger"));
var _pixelmon = require("./pixelmon");
var _track = _interopRequireDefault(require("./track"));
var logger = (0, _getLogger["default"])('reportNewView', 'warn');

// `newViewCount` will be used in the we_sdk context packer. (Open question: should this be owned in React state? For now we just take advantage of this module being singleton-y)
var newViewCount = 0;

/**
 * Report to the `we-sdk` that from here on out, we should consider this a new `view`.
 * Often fired in response to a "replay" event of some sorts.
 *
 * This has two implications:
 * 1) Fires a `"newview"` event to analytics
 * 2) Resets the state of pixelmon such that fired pixels with `oncePerView === true` can fire once again
 * @export
 * @method module:utils#reportNewView
 */
function reportNewView() {
  logger.debug('[utils/reportNewView]::');

  // Forward the reportNewView() to pixelmonInstance - it should reset its oncePerView state
  (0, _pixelmon.getPixelmonInstance)().reportNewView();

  // Track it - this tracks an event called `newview` to EA, and also allows pixels to be connected to the `newview` event
  (0, _track["default"])('newview');
  newViewCount += 1;
}
var _default = exports["default"] = reportNewView;
function getNewViewCount() {
  return newViewCount;
}